var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('file-pond',{ref:"pond",attrs:{"name":"test","label-idle":"<small><i>Arrastra tus archivos aquí...</i></small>","allow-multiple":_vm.multiple},on:{"addfile":_vm.handleUpload,"removefile":_vm.handleCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }